import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';

import { ChatComposerComponent } from './chat-composer.component';
export { ChatComposerComponent };

import { ChatComposerActionsDirective } from './directives/chat-composer-actions.directive';
export { ChatComposerActionsDirective };

import { ChatComposerActionsExtendedDirective } from './directives/chat-composer-actions-extended.directive';
export { ChatComposerActionsExtendedDirective };

import { ChatComposerActionButtonDirective } from './directives/chat-composer-action-button.directive';
export { ChatComposerActionButtonDirective };

import { ChatComposerSendOverrideDirective } from './directives/chat-composer-send-override.directive';
export { ChatComposerSendOverrideDirective };

import { ChatComposerBesideSendDirective } from './directives/chat-composer-beside-send.directive';
import {
  GalaxyButtonLoadingIndicatorModule,
  GlxyButtonProgressIndicatorDirective,
} from '@vendasta/galaxy/button-loading-indicator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
export { ChatComposerBesideSendDirective };

import { ChatSourceId } from './chat-composer.component';
export { ChatSourceId };

import { TranslateModule } from '@ngx-translate/core';
export { TranslateModule };

export const MODULE_IMPORTS = [
  CommonModule,
  MatButtonModule,
  MatIconModule,
  TextFieldModule,
  MatMenuModule,
  MatTooltipModule,
  FormsModule,
  GalaxyButtonLoadingIndicatorModule,
  GlxyButtonProgressIndicatorDirective,
  MatProgressSpinnerModule,
  TranslateModule,
];

export const MODULE_DECLARATIONS = [
  ChatComposerComponent,
  ChatComposerActionsDirective,
  ChatComposerActionsExtendedDirective,
  ChatComposerActionButtonDirective,
  ChatComposerBesideSendDirective,
  ChatComposerSendOverrideDirective,
];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: MODULE_DECLARATIONS,
})
export class GalaxyChatComposerModule {}
